import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getQuestionsList } from "../../../Redux/reducer/questions";
import CustomSelect from "../../shared/custom-components/select";
import * as QuestionsActions from "../../../Redux/actions/questionsActions";

export class QuestionsComponent extends Component {
  componentDidMount() {
    const {
      questions,
      actions: { getQuestions },
    } = this.props;

    if (questions.length <= 0) {
      getQuestions();
    }
  }

  render() {
    const { questions, onChange, name, value, readOnly = false } = this.props;

    return (
      <CustomSelect
        id={name}
        value={value}
        name={name}
        valueAttr={`id`}
        className="input input--text input-w-aux__input input--active"
        items={questions}
        handleChange={onChange}
        readOnly={readOnly}
      />
    );
  }
}

QuestionsComponent.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};

export const mapStateToProps = (state) => {
  return {
    questions: getQuestionsList(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(QuestionsActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatch
)(QuestionsComponent);
